export default "__VITE_ASSET__5nLYEQjB__"